import React from 'react'
import './Testimonial.css'

const education = [
 ['Bachelor’s Degree','Computer Networks and Telecommunications','ISESOD · 2023–2024'],
 ['Associate Degree','Computer Networks and Telecommunications','ISESOD · 2021–2022'],
 ['High School Diploma','Business Administration and Management','Complexe Scolaire de Base · 2018–2019']
]
const certs=['CCNAv7 — Cisco Networking Academy','IT Essentials — Cisco Networking Academy','Get Connected — Cisco Networking Academy','English Language Certificate']

const Testimonial = () => (
 <section className='career-section site-shell' id='Career'>
  <div className='section-header'><span className='section-eyebrow'>Education & certifications</span><h2 className='section-title'>Technical foundation and continuous learning</h2></div>
  <div className='education-layout'><div>{education.map(([degree,field,meta])=><article className='education-card' key={degree}><span>{meta}</span><h3>{degree}</h3><p>{field}</p></article>)}</div><aside className='cert-card'><h3>Certifications</h3>{certs.map(c=><div key={c}>✓ {c}</div>)}<h3>Languages</h3><div>French — Native or bilingual</div><div>Swahili — Professional working</div><div>English — Limited working</div></aside></div>
 </section>
)
export default Testimonial
